import { useState } from 'react';
import {
  Box,
  Divider,
  Avatar,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Button,
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import PersonIcon from '@mui/icons-material/Person';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import GroupsIcon from '@mui/icons-material/Groups';
import LogoutIcon from '@mui/icons-material/Logout';
import BusinessIcon from '@mui/icons-material/Business';
import PsychologyIcon from '@mui/icons-material/Psychology';
import AutorenewIcon from '@mui/icons-material/Autorenew';

export const UserMenu = ({
  user,
  onOpenProfile,
  onLogout,
  onOpenCompanyAdmin
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const displayText = user?.display_name || user?.email || 'User';
  const initial = displayText.charAt(0).toUpperCase();
  const showCompanyAdmin = user?.role === 'company_admin' || user?.role === 'company_owner' || user?.role === 'super_admin';
  const showSuperAdmin = user?.role === 'super_admin';

  return (
    <Box sx={{ borderTop: 1, borderColor: 'divider' }}>
      {/* Super Admin Link */}
      {showSuperAdmin && (
        <Box sx={{ p: 1.5 }}>
          <Button
            href="super-admin.html"
            fullWidth
            startIcon={<BusinessIcon />}
            sx={{
              justifyContent: 'flex-start',
              px: 1.5,
              py: 1,
              textTransform: 'none',
              color: 'text.primary',
              '&:hover': { bgcolor: 'action.hover' },
            }}
          >
            Super Admin
          </Button>
        </Box>
      )}

      {/* User Profile */}
      <Box sx={{ p: 1.5, borderTop: showSuperAdmin ? 1 : 0, borderColor: 'divider' }}>
        <Button
          onClick={handleClick}
          fullWidth
          sx={{
            justifyContent: 'flex-start',
            p: 0.5,
            textTransform: 'none',
            color: 'text.primary',
            '&:hover': { bgcolor: 'action.hover' },
          }}
        >
          <Avatar
            sx={{
              width: 32,
              height: 32,
              bgcolor: 'primary.main',
              fontSize: '0.875rem',
              fontWeight: 600,
              mr: 1,
            }}
          >
            {initial}
          </Avatar>
          <Typography
            variant="body2"
            noWrap
            sx={{ flex: 1, textAlign: 'left' }}
          >
            {displayText}
          </Typography>
          <SettingsIcon sx={{ fontSize: 18, color: 'text.secondary', ml: 1 }} />
        </Button>

        {/* Dropdown Menu */}
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          slotProps={{
            paper: {
              sx: {
                minWidth: 180,
                mb: 1,
              },
            },
          }}
        >
          <MenuItem
            onClick={() => {
              handleClose();
              onOpenProfile();
            }}
          >
            <ListItemIcon>
              <PersonIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Profile</ListItemText>
          </MenuItem>

          <MenuItem
            onClick={() => {
              handleClose();
              window.location.href = '/manage-assistants.html';
            }}
          >
            <ListItemIcon>
              <SmartToyIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Manage Assistants</ListItemText>
          </MenuItem>

          <MenuItem
            onClick={() => {
              handleClose();
              window.location.href = '/memories.html';
            }}
          >
            <ListItemIcon>
              <PsychologyIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Memories</ListItemText>
          </MenuItem>

          <MenuItem
            onClick={() => {
              handleClose();
              window.location.href = '/recurring-tasks.html';
            }}
          >
            <ListItemIcon>
              <AutorenewIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Recurring Tasks</ListItemText>
          </MenuItem>

          {showCompanyAdmin && (
            <MenuItem
              onClick={() => {
                handleClose();
                onOpenCompanyAdmin();
              }}
            >
              <ListItemIcon>
                <GroupsIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Company Admin</ListItemText>
            </MenuItem>
          )}

          <MenuItem
            onClick={() => {
              handleClose();
              onLogout();
            }}
          >
            <ListItemIcon>
              <LogoutIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Logout</ListItemText>
          </MenuItem>
        </Menu>
      </Box>
    </Box>
  );
};
